import script from "./ExepnseManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExepnseManage.vue?vue&type=script&setup=true&lang=js"

import "./ExepnseManage.vue?vue&type=style&index=0&id=4dc43f1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc43f1a"]])

export default __exports__